






import Vue from 'vue';
import AppModule from '../../common/components/AppModule.vue';
import {AppModuleConfig, AppModuleNavItem} from '../../common/models/AppModuleConfig';
import { access } from 'fs';

const moduleNavs: AppModuleNavItem[] = [];
const module: AppModuleConfig = {
  module: 'account',
  name: '公众号设置',
  navs: moduleNavs,
  description: undefined,
};

export default Vue.extend({
  components: {
    AppModule,
  },
  data() {
    return {
      module,
    };
  },
});
